import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 200px;
  color: #fff;
  margin: 0 15px;
  font-size: 4em;
  
`;